import { useContext, useEffect, useRef, useState } from "react";
import { GridLoader } from "../../rcsgrid/createGridTools";
import { DefaultDialogContentProps } from "./DialogAcctools";
import { formEdit } from "../../Tools/Tools";
import ContextMenu from "../../NotWorkArea(Side&Head)/ContextMenu";
import { createGrid, createRecordSource } from "../../rcsgrid/rcsgrid";
import { getObjText } from "../../Tools/Requests";
import clsx from "clsx";
import dialogStyles from "./Components/dialogStyles.module.css";
import { SmetaModalsButtonsContext } from "../../Tools/modalManager";

const checkRequest = (data: {
  gridObj: { grid: createGrid; source: createRecordSource };
  keyField?: string;
  selectKey?: string;
}) => {
  if (data.selectKey === "RecordIndex") {
    return {
      Name: "RecordIndex",
      Value: data.gridObj?.source.activeRecord,
    };
  }

  const reqValue =
    data.keyField === "Code"
      ? data.gridObj?.source.getFieldValueSync("CODE")
      : data.gridObj?.source.getFieldTextSync(data.keyField?.toUpperCase() || "ID");
  return {
    Name: data.selectKey || "ObjRef",
    Value: reqValue,
  };
};

export default function DialogBook({ props }: DefaultDialogContentProps) {
  const {
    Module: module,
    ObjType: objType,
    Name: name,
    record,
    RequestID: requestId,
    addInfo,
    from,
    Buttons: buttons,

    onEdit,
    setValue,
    setInputValue,
    func,
    selectKey,
    KeyField: keyField,
    FieldName: fieldName,
    Current: current,
    hiddenButton,
  } = props;

  const gridpanelRef = useRef(null);
  const [mainGrid, setMainGrid] = useState<{ grid: createGrid; source: createRecordSource }>();

  useEffect(() => {
    loadGrid();
  }, []);

  const setButtons = useContext(SmetaModalsButtonsContext);

  useEffect(() => {
    if (hiddenButton) return;
    const modalButtons: { [key: number]: { label: string; onClick: () => void } } = {};
    if (!buttons || Number(buttons) & 1) {
      modalButtons[1] = { label: "Выбрать", onClick: onSelect };
    }
    setButtons?.(modalButtons);
  }, [setButtons, mainGrid]);

  const loadGrid = async () => {
    setMainGrid(await GridLoader(gridpanelRef.current, props));
  };

  const getGridMultiSelect = async (grid: createGrid) => {
    const multiSelect = grid.getMultiSelect();
    if (multiSelect.length === 0) {
      return 0;
    } else {
      return multiSelect.join(",");
    }
  };

  async function onSelect() {
    if (!mainGrid) return;
    const request = checkRequest({ gridObj: mainGrid, keyField, selectKey });
    const gridSelection = await getGridMultiSelect(mainGrid.grid);

    if (requestId) {
      await formEdit("1", func, { ...request, Selection: gridSelection }, requestId, from);
      return;
    }

    if (onEdit) {
      const tag =
        keyField === "Code"
          ? mainGrid.source.getFieldValueSync("CODE")
          : mainGrid.source.getFieldTextSync(keyField?.toUpperCase() || "ID");

      const editData = {
        tag: tag,
        name: name,
        setValue: setValue,
        setInputValue: setInputValue,
        type: module,
        requestId: requestId,
        addInfo: addInfo,
      };

      if (record) {
        onEdit({
          ...editData,
          fieldname: fieldName,
          current: current,
          record: record,
          textchanged: "0",
        });
        return;
      } else {
        onEdit({
          ...editData,
          value: (await getObjText(module, objType || "0", tag, "0"))?.Text,
        });
        return;
      }
    }
  }

  return (
    <>
      <div className={clsx(dialogStyles.mainDialogBlock)}>
        <div className={clsx(dialogStyles.fullDialogFlexContainer)}>
          <ContextMenu for={"grid"} refs={gridpanelRef.current}>
            <div
              id="rcgrid_panel"
              ref={gridpanelRef}
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
              }}
            ></div>
          </ContextMenu>
        </div>
      </div>
    </>
  );
}
